// extracted by mini-css-extract-plugin
module.exports = {"TagIcon":"ModulesView_TagIcon__21Tby"};